<popup zIndex="9999999" [system]="true" [header]="viewForm.title" [(visible)]="display" modal="modal" width="450"
    responsive="true" (onShow)="onShow()" (onHide)="onHide($event)">

    <div class="modal_area" *ngIf="viewForm">
        <p>{{'親愛的使用者您好:'|i18n:'chm00005200':null}}
            <br>
            <span>
                {{'您在本系統已閒置超過'|i18n:'chm00001688':null}}{{minute}}{{'分鐘，本系統將於'|i18n:'chm00002916':null}}
            </span>

            <span class="txt_red">{{viewForm.timeout}}{{'秒'|i18n:'chm00005832':null}}</span>
            <span>{{'後自動登出，若您需繼續使用，請按'|i18n:'chm00003393':null}}</span>
            <span class="txt_blue">"{{'繼續'|i18n:'common00001424':null}}"</span>
            <span>{{', 或直接按'|i18n:'chm00000481':null}}</span>
            <span class="txt_blue">"{{'登出'|i18n:'chm00002815':null}}"</span>{{'，登出本系統。'|i18n:'chm00002776':null}}
        </p>

        <div class="btn_box">
            <commandButton [mask]="false" (onClick)="onHide($event)">{{'繼續'|i18n:'common00001424':null}}</commandButton>
            <commandButton [mask]="false" (onClick)="doConfirm($event)">{{'登出'|i18n:'chm00002815':null}}</commandButton>
        </div>
    </div>


</popup>